import { queryOptions, skipToken } from '@tanstack/react-query';

import { getGroupInfos } from './api';

export const groupQueries = {
  all: (group: string) => ['group', group] as const,
  infos: (group: string) =>
    queryOptions({
      queryKey: [...groupQueries.all(group), 'infos'],
      queryFn: group ? () => getGroupInfos(group) : skipToken,
    }),
};
